import { ApolloError } from '@apollo/client';
import { BillingProfile, InvoiceGroup, PaymentMethodTypeV2 } from '@css-xp/graphtypes/src/generated-types-new';
import { OnUpdateCallbacks } from './hooks/types';
import { CreatePaymentMethodContext } from '@css-xp/ppc-paypal';

export type AddPaymentMethodProps = {
  txaId: string;
  onCancel: () => void;
  sidebarClassName?: string;
  showSubscriptionChargeNote?: boolean;
  header?: string;
  subHeader?: string | JSX.Element;
  version?: number;
  isPaypalSupportEnabled?: boolean;
  paypalEmail?: string;
  payPalEmails?: string[];
  shouldShowACHPaymentMethod?: boolean;
} & OnUpdateCallbacks;

export type EditPaymentMethodProps = {
  txaId: string;
  paymentMethodId: string;
  onCancel: () => void;
  showSubscriptionChargeNote?: boolean;
  version?: number;
} & OnUpdateCallbacks;

export enum PaymentMethodOperation {
  ADD = 'Add',
  EDIT = 'Edit',
  REPLACE = 'Replace',
}

export type PaymentMethodFormProps = {
  txaId: string;
  operation: PaymentMethodOperation;
  isOperationInProgress: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  onPaypalSubmit?: (transactionAccountId: string, paymentMethodContext: CreatePaymentMethodContext | null) => void;
  sidebarClassName?: string;
  showSubscriptionChargeNote?: boolean;
  header?: string;
  subHeader?: string | JSX.Element;
  version?: number;
  isLoadingBillingProfiles?: boolean;
  billingProfiles?: BillingProfile[];
  isPaypalOperationInProgress?: boolean;
  editPaymentMethod?: boolean;
  paypalEmail?: string;
  isPaypalSelectionEnabled?: boolean;
  paymentMethod?: PaymentMethodTypeV2;
  payPalEmails?: string[];
  shouldShowACHPaymentMethod?: boolean;
  onUpdateDone?: () => void;
  onUpdateFailure?: () => void;
  onUpdateSuccess?: () => void;
};

export type AssociatedBillingProfilesProps = {
  isLoadingBillingProfiles?: boolean;
  billingProfiles?: BillingProfile[] | InvoiceGroup[];
  txaId: string;
  infoMessage?: string | JSX.Element;
  error?: ApolloError;
  shouldHideDetails?: boolean;
  isBillingProfileClickable?: boolean;
  shouldHideCountBadge?: boolean;
};
